module.exports = __webpack_public_path__ + "static/the-feels-68ebbf5435bedae0cede8515c5193de4.png";